import { createSignal } from "solid-js";

// LocaleService is an interface that defines the methods for managing
// locales in the application.
export interface LocaleService {
  getLocale: () => LocaleKey;
  setLocale: (locale: LocaleKey) => void;
  getAvailableLocales: () => LocaleOptions;
  getDefaultLocale: () => LocaleKey;
}

type LocaleKey = "en" | "es" | "fr" | "de";
type LocaleOptions = {
  [key in LocaleKey]: {
    name: string;
  };
};

const AvailableLocales: LocaleOptions = {
  en: { name: "English" },
  es: { name: "Spanish" },
  fr: { name: "French" },
  de: { name: "German" },
};

const defaultLocale = "en" as LocaleKey;

// useLocaleService is a hook that provides the locale service which manages
// the state of the current locale and provides methods to get and set
// the locale. It may be used in conjunction with internationalization
// or localization libraries to provide a better user experience.
export const useLocaleService = () => {
  const [locale, setLocale] = createSignal(defaultLocale);

  return {
    getLocale: () => locale(),
    setLocale: (newLocale: LocaleKey) => setLocale(newLocale),
    getAvailableLocales: () => AvailableLocales,
    getDefaultLocale: () => defaultLocale,
  };
};
